import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import PageLoading from '../common/components/elements/PageLoading';

export function Redirector() {
  const [query] = useSearchParams();

  useEffect(() => {
    window.open(query.get('url'), '_self');
  }, [query]);

  return <PageLoading />;
}
